import { render, staticRenderFns } from "./OriginDestinationStep.vue?vue&type=template&id=65929955&scoped=true"
import script from "./OriginDestinationStep.vue?vue&type=script&lang=js"
export * from "./OriginDestinationStep.vue?vue&type=script&lang=js"
import style0 from "./OriginDestinationStep.vue?vue&type=style&index=0&id=65929955&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65929955",
  null
  
)

export default component.exports